import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./maillist.module.scss";
import MailItem from "./mailItem";
import analyticsUtil from "../../utils/segmentUtils";

class MailList extends Component {
    componentDidMount = () => {
        this.props.setMailThreads({ mails: this.props.mails });
        analyticsUtil.page('Mail list page')
    };

    componentWillReceiveProps = nextProps => {
        if (nextProps.mails.length !== this.props.mails.length) {
            this.props.setMailThreads({ mails: nextProps.mails });
        }
    };

    getMailItems = mails => {
        return mails.map((mail, index) => {
            return (
                <MailItem
                    {...mail}
                    key={mail.id}
                    mailIndex={index}
                    tutorial={this.props.tutorial}
                    startTutorial={this.props.startTutorial}
                    stopTutorial={this.props.stopTutorial}
                    addStepsToTutorial={this.props.addStepsToTutorial}
                    updateStepNumber={this.props.updateStepNumber}
                    mailSequence={this.props.mailSequence}
                    actors={this.props.actors}
                    addMailReadFlag={this.props.addMailReadFlag}
                    addMailStarredFlag={this.props.addMailStarredFlag}
                    setSurveyCompleteFlag={this.props.setSurveyCompleteFlag}
                    getTimeData={this.props.getTimeData}
                    autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
                    removeMailStarredFlag={this.props.removeMailStarredFlag}
                    setCurrentMailIndex={this.props.setCurrentMailIndex}
                />
            );
        });
    };

    render() {
        return (
            <div className={styles.container}>
                {this.getMailItems(this.props.primaryMails)}
            </div>
        );
    }
}

MailList.propTypes = {
    primaryMails: PropTypes.array
};

MailList.defaultProps = {
    primaryMails: []
};

export default MailList;



// WEBPACK FOOTER //
// /src/components/mailList/MailList.js